// @ts-check
import React from 'react';
import { Row, Widget } from 'shared/containers/portal_layout';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { usePortalConfig } from 'shared/context/PortalConfig';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ToggleSwitch from 'shared/components/ToggleSwitch';

export const AcceptingNewPatientsForm = props => {
  const {
    params: { entityId },
  } = props;
  const { apiPrefix } = usePortalConfig();

  const queryClient = useQueryClient();
  const queryKey = `location-${entityId}`;
  const { isIdle, isLoading, data, error } = useQuery(queryKey, () =>
    api.get(`${apiPrefix}/locations/${entityId}`).then(resp => resp.data)
  );

  const mutation = useMutation(
    locationInput => api.put(`${apiPrefix}/locations/${entityId}`, locationInput),
    {
      onSuccess: () => {
        queryClient.setQueryData(queryKey, old => ({
          ...old,
          location: {
            ...old.location,
            acceptingNewPatients: !old.location.acceptingNewPatients,
          },
        }));
        FlashMessageActions.flashSuccess({ message: 'Setting updated.' });
      },
    }
  );

  return (
    <Row>
      <Widget title="Accepting New Patients" span={12} nopadding>
        {isIdle || isLoading ? (
          <LoadingContent />
        ) : error || !data.location ? (
          <p>Failed to load.</p>
        ) : (
          <>
            <div className="p-4 flex items-center">
              <div className="flex-grow">
                <p style={{ margin: 0 }} className="text-base font-semibold leading-6">
                  Accepting new patients
                </p>
                <p style={{ margin: 0 }} className="text-sm">
                  When set to "No", a message will be displayed to referring users.
                </p>
              </div>
              <div className="pl-4">
                <ToggleSwitch
                  id="accepting-new-patients"
                  loading={mutation.isLoading}
                  checked={data.location.acceptingNewPatients}
                  onChange={() =>
                    mutation.mutate({
                      input: { accepting_new_patients: !data.location.acceptingNewPatients },
                    })
                  }
                  showStateLabel
                  onStateLabel="Yes"
                  offStateLabel="No"
                />
              </div>
            </div>
          </>
        )}
      </Widget>
    </Row>
  );
};
